export function becomeHostStepInfo(formPage) {
  let step;
  const step1Pages = [
    "room",
    "room-type",
    "bedrooms",
    "bathrooms",
    "location",
    "map",
    /* "amenities", */
    /* "spaces", */
  ];

  const step2Pages = ["amenities", "photos", "review-photos", "cover-photo"];
  const step3Pages = [
    "title",
    "description", 
    "min-max-nights",
    "guest-requirements",
    "house-rules",
    "review-how-guests-book",
    "advance-notice",
    "booking-window",
    "calendar",
    "pricing",
    "discount",
    "booking-scenarios",
    "local-laws",
  ];

  if (step1Pages.indexOf(formPage) > -1) {
    step = 1;
  } else if (step2Pages.indexOf(formPage) > -1) {
    step = 2;
  } else if (step3Pages.indexOf(formPage) > -1) {
    step = 3;
  }
  return step;
}
